import http from "./httpService";

const endPoint = "/api/longDivision";

export function runLongDivision(data) {
  return http.post(endPoint, data);
}
